import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { LabelledPropertyX } from 'framework/components/labelledProperty/LabelledPropertyX';
import { IPatient } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { PatchPatientBsnRequestForm } from '../../forms/PatchPatientBsnRequestForm';
import { PatchPatientOriginalNoRequestForm } from '../../forms/PatchPatientOriginalNoRequestForm';
import { PatchPatientReferenceRequestForm } from '../../forms/PatchPatientReferenceRequestForm';
import { IconButton } from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { useSnackbarNotify } from 'framework/hooks/useSnackbarNotify';

interface IProps {
	item: IPatient;
	reload: VoidFunction;
	style?: React.CSSProperties;
}

export const PatientNumberingCardContent = ({ item, reload, style }: IProps) => {
	const strings = useLocalization();
	const { open, confirm, cancel } = useDialogsContext(reload);
	const notify = useSnackbarNotify();

	const onPatchReference = () => {
		open(
			<PatchPatientReferenceRequestForm
				open
				confirm={confirm}
				cancel={cancel}
				patient={item}
			/>
		);
	};

	const onPatchOriginalNo = () => {
		open(
			<PatchPatientOriginalNoRequestForm
				open
				confirm={confirm}
				cancel={cancel}
				patient={item}
			/>
		);
	};

	const onPatchBsn = () => {
		open(
			<PatchPatientBsnRequestForm
				open
				confirm={confirm}
				cancel={cancel}
				patient={item}
			/>
		);
	};

	return (
		<div
			className='df-col gap-8'
			style={style}>
			<CardTitleTypography title={strings.numbering} />
			<LabelledPropertyX
				label={'NR'}
				edit={onPatchReference}>
				<div className='df-row-ac'>
					<div style={{ marginRight: 4 }}>{item.reference}</div>
					<IconButton
						edge='end'
						size='small'
						onClick={e => {
							e.stopPropagation();
							e.preventDefault();
							navigator.clipboard.writeText(item.reference ?? '');
							notify(strings.copiedToClipboard, 'success');
						}}>
						<FileCopyOutlinedIcon fontSize='small' />
					</IconButton>
				</div>
			</LabelledPropertyX>
			<LabelledPropertyX
				edit={onPatchOriginalNo}
				label='Pre migr. NR'>
				{item.originalPatientNo}
			</LabelledPropertyX>
			<LabelledPropertyX
				edit={onPatchBsn}
				label='BSN'>
				{item.bsn}
			</LabelledPropertyX>
		</div>
	);
};
